import { Component, ElementRef, OnInit } from '@angular/core';

import { HomeWidget } from '../dashboard-widget.utils';

@Component({
  selector: 'app-bar-chart-widget',
  templateUrl: './bar-chart-widget.component.html',
  styleUrls: ['./bar-chart-widget.component.scss']
})
export class BarChartWidgetComponent extends HomeWidget implements OnInit {
  constructor(elRef: ElementRef) {
    super(elRef);
  }

  ngOnInit(): void {}
}
